import axios from "./axios"

const MATERIALS_NICENAME_TO_SUPPORT: Record<string, boolean> = {
    "materials.plastic": true,
    "materials.metal_plastic": true,
    "materials.metal": true,
    "materials.stone_newlight": true,
    "materials.stone": true,
    "materials.stone_lepietre": false,
    "materials.gres_60": false,
    "materials.gres_90": false,
}

export const canSupportFurnishingsByNiceName: (material_nicename: string) => boolean = (material_nicename: string) => {
    const support = MATERIALS_NICENAME_TO_SUPPORT[material_nicename]
    if (support !== undefined) {
        return support
    }
    console.warn(`Unknown furnishings support for material ${material_nicename}`)
    return false
}


export interface MaterialEntry {
    id: number
    nicename: string
}

// NOTE: Do not try to load the materials data before login.
//       Otherwise, it would 401 and redirect to the Login page, refreshing the login page itself in a loop.

let _globalMaterialsDataCache: MaterialEntry[] | null = null;

export const asyncCanSupportFurnishingsByMaterialId: (materialId: number) => Promise<boolean> = async (materialId: number) => {
    try {
        if (_globalMaterialsDataCache === null) {
            const res = await axios.post("/planner/materials")
            _globalMaterialsDataCache = res.data?.materials
        }
        const material = _globalMaterialsDataCache?.find?.(m => m.id === materialId)
        const nicename = material?.nicename
        if (!nicename) {
            console.error(`Unknown material nicename from id ${materialId}`)
            return false
        }
        console.debug(`Material nicename for id ${materialId} is ${nicename}`)
        return canSupportFurnishingsByNiceName(nicename)
    } catch (error) {
        console.error('Error while loading materials data for furnishings support:', error)
    }
}
